module.exports = __webpack_public_path__ + "Roboto-Thin.954bbdeb86483e4ffea0.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/font/roboto/Roboto-Thin.woff2
// module id = ../../../../../font/roboto/Roboto-Thin.woff2
// module chunks = styles